<template>
  <pre v-html="result"></pre>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";
import { highlightJSON } from "@/utils";

export default Vue.extend({
  name: "JsonPreview",

  data() {
    return {};
  },
  props: {
    obj: VueTypes.any,
  },
  methods: {
    highlightJSON,
  },
  computed: {
    result(): string {
      return highlightJSON(this.obj);
    },
  },
});
</script>
<style>
pre {
  /* outline: 1px solid #ccc; */
  padding: 5px;
  margin: 5px;
}
pre .string {
  color: green;
}
pre .number {
  color: darkorange;
}
pre .boolean {
  color: blue;
}
pre .null {
  color: magenta;
}
pre .key {
  color: orangered;
}
</style>
